export enum TicketType {
    Single = "single",
    Kombi = "kombi",
    Ako = "ako",
}

export enum TicketKind {
    Default = "default",
    Shared = "shared",
    Miniticket = "miniticket",
}
